"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggle = void 0;

var _stylitas = require("@creditas/stylitas");

const toggleEnabled = ({
  enabled
}) => enabled && (0, _stylitas.css)`
    background: linear-gradient(
      90deg,
      rgba(17, 187, 119, 1) 0%,
      rgba(51, 119, 187, 1) 100%
    );

    :after {
      left: unset;
      right: 2px;
    }
  `;

const toggle = ({
  theme,
  enabled
}) => (0, _stylitas.css)`
  background-color: ${theme.bColorneutral04};
  border-radius: 16px;
  cursor: pointer;
  height: 24px;
  position: relative;
  width: 48px;

  :after {
    background-color: white;
    border-radius: 10px;
    content: '';
    height: 20px;
    left: 2px;
    position: absolute;
    top: 2px;
    width: 20px;
  }

  ${toggleEnabled({
  theme,
  enabled
})}
`;

exports.toggle = toggle;